var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.5,
    height: 22.5,
    viewBox: "0 0 24.5 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1770",
    transform: "translate(.75 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3128",
    d: "M1139.09 1245.5h-9.59a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.25",
    transform: "translate(-1128.5 -1226.548)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 773",
    transform: "translate(0 7)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0h20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 774",
    transform: "translate(4)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0v3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 775",
    transform: "translate(16)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0v3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 398",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(13 11)",
    style: {
      stroke: "#2a32ff",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 776",
    transform: "translate(18 13)",
    style: {
      stroke: "#2a32ff",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0v3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 777",
    transform: "translate(18 16)",
    style: {
      stroke: "#2a32ff",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M2 2 0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b43235169d6ae0ef6c3c485cd990bcef.svg";
export { ForwardRef as ReactComponent };